// Core packages
import { Component, OnDestroy, OnInit } from '@angular/core';

// Third party packages
import { MatDialog } from '@angular/material';
import { Subscription } from 'rxjs';

// Custom packages
import { TranslateService } from '@ngx-translate/core';
import { SITISRLDialogComponent } from 'src/app/shared/components/dialogs/sitisrl-dialog/sitisrl-dialog.component';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  year: number = new Date().getFullYear();

  constructor(
    public configService: ConfigService,
    public dialog: MatDialog,
    private translateService: TranslateService,
  ) { }

  /**
   * Init component
   *
   * @returns undefined
   */
  ngOnInit(): void {
  }

  /**
   * Handle component destroy
   *
   * @returns undefined
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handle click on credit link and opena custom dialog
   *
   * @since 1.0.0
   */
  onCreditLinkClick(): void {
    this.dialog.open(SITISRLDialogComponent, {
      width: '475px',
      minWidth: '400px',
      maxHeight: '98vh',
      data: {}
    });
  }


}
